// removed by extract-text-webpack-plugin
module.exports = {"messageBody":"followSuggestionModal__messageBody__95aac937"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/finding/components/FollowSuggestionModal/followSuggestionModal.scss
// module id = 4198
// module chunks = 62